module.exports = __webpack_public_path__ + "img/1483895479.6a4d82e4.jpg";